import { render, staticRenderFns } from "./ShareToTeamForEdit.vue?vue&type=template&id=57fd699d&scoped=true&"
import script from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"
export * from "./ShareToTeamForEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fd699d",
  null
  
)

export default component.exports